export const RANGE_DELIMITER = " - "

export const RANGE_DELIMITER_QUERY_STRING = ","

export const TIME_DELIMITER = "T"

export const TIME_FORMAT = "lll"

export const DATE_FORMAT_ISO_FORMAT = "YYYY-MM-DD"

export const DATE_TIME_LT_FORMAT = `${DATE_FORMAT_ISO_FORMAT}${TIME_DELIMITER}HH:mm`

export const TIME_DISPLAY_FORMAT_REGEX =
  /^([A-Za-z]{3} \d{1,2}, \d{4} \d{1,2}:\d{2} (AM|PM))\s*-\s*([A-Za-z]{3} \d{1,2}, \d{4} \d{1,2}:\d{2} (AM|PM))$/
